import * as React from "react"
import { capitalizeWords } from "../../helpers/helpers";
import { Link } from 'gatsby-plugin-react-i18next';
import "./emoji-grid-card.css"
import { useI18next } from 'gatsby-plugin-react-i18next';

const EmojiGridCard = ({ emoji }) => {
    const { language } = useI18next();

    return (
        <Link to={`/emoji/${emoji.url}`} className="sidebar-option">
            <div className="grid-card border">
                <div className="grid-card-content card-content-column">
                    <div className="grid-card-content-line">
                        <div className="grid-emoji mb-4">{emoji.emoji}</div>
                        <div className="grid-emoji-title">{capitalizeWords(emoji.name[language] || emoji.name.en)}</div>
                    </div>
                </div>
            </div>
        </Link>

    )
}

export default EmojiGridCard
